import { useContext } from "react";

import { GuestContext } from "../../contexts/super/GuestContext";

const useGuest = () => {
  const context = useContext(GuestContext);
  return context;
};

export default useGuest;
